import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import NoDataImage from "assets/images/no-data2.svg";

type NoTasksPlacholderProps = {
  label: string;
  onCreateNew?: () => void;
};

export default function NoTasksPlaceholder({
  label,
  onCreateNew,
}: NoTasksPlacholderProps) {
  return (
    <Stack direction="row" columnGap={2.5} p={2}>
      <Box
        component="img"
        src={NoDataImage}
        alt=""
        sx={{ height: "130px", pl: 2 }}
      ></Box>
      <Stack>
        <Typography
          variant="body3"
          fontWeight={700}
          sx={{ mb: 2, color: grey[900] }}
        >
          {label}
        </Typography>
        <Typography variant="body3">
          It looks like there&nbsp;are no&nbsp;tasks available here.
        </Typography>

        <Link
          sx={{
            cursor: "pointer",
          }}
          onClick={(event) => {
            event.preventDefault();
            onCreateNew?.();
          }}
        >
          <Typography variant="body2" mt={1.5}>
            + Create a New Task
          </Typography>
        </Link>
      </Stack>
    </Stack>
  );
}
